import { Component, Input } from '@angular/core';
import { Gicop } from '../../../model/gicop-notifications';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatDivider } from '@angular/material/divider';
import { CustomerContactTableComponent } from './customer-contact-table/customer-contact-table.component';
import { CustomerFeedbackTableComponent } from './customer-feedback-table/customer-feedback-table.component';
import { PotentialBreachCodeTableComponent } from './potential-breach-code-table/potential-breach-code-table.component';
import { CustomerVulnerabilityTableComponent } from './customer-vulnerability-table/customer-vulnerability-table.component';
import { DatePipe } from '../../../pipes/date.pipe';

@Component({
  selector: 'app-gicop-notifications-curtain',
  templateUrl: './gicop-notifications-curtain.component.html',
  styleUrls: ['./gicop-notifications-curtain.component.scss'],
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatDivider,
    CustomerContactTableComponent,
    CustomerFeedbackTableComponent,
    PotentialBreachCodeTableComponent,
    CustomerVulnerabilityTableComponent,
    DatePipe
  ]
})
export class GicopNotificationsCurtainComponent {
  @Input() gicopNotifications: Gicop;
  @Input() timezone: string;
  constructor() {}
}
